import { features } from "ui/features";

import { baseService } from "./base";

class NetworkService {
  load() {
    return baseService.get("/api/networks");
  }

  loadAll() {
    return baseService.get("/api/networks/all");
  }

  new(name, vistarNetwork) {
    const data = { name };
    if (vistarNetwork) {
      data.vistar_api_key = vistarNetwork.api_key;
      data.vistar_network_id = vistarNetwork.id;
    }

    return baseService.post("/api/network", data);
  }

  delete(networkId) {
    return baseService.delete(`/api/network/${networkId}`);
  }

  get(networkId) {
    return baseService.get(`/api/network/${networkId}`);
  }

  updateParams(networkId, params) {
    const url = features.APP_PARAMETERS_V3
      ? `/api/network/v2/${networkId}/params`
      : `/api/network/${networkId}`;

    return baseService.put(url, { params: params });
  }

  updateFlags(networkId, flags) {
    return baseService.put(`/api/network/${networkId}/flags`, { flags: flags });
  }

  updateDetails(networkId, details) {
    return baseService.put(`/api/network/${networkId}/details`, {
      agentVersion: details.agentVersion,
      disableRemoteUpdates: details.disableRemoteUpdates,
      day: details.day,
      hour: details.hour,
      playerVersion: details.playerVersion,
      sandboxStatus: details.sandboxStatus,
      networkName: details.networkName,
      operateParams: details.operateParams,
    });
  }
}

const networkService = new NetworkService();

export default networkService;
export { networkService, NetworkService };
